export const MinPriceFreeShipping = 3500;
